// extracted by mini-css-extract-plugin
module.exports = {"root":"_2mGzc","slider":"_1ko4B","optionHandleGrey":"_1dkVk","optionHandleGreen":"di4kC"};